import type { RouteLocationNormalized } from 'vue-router'
import { i18n } from '@/i18n'

/**
 * 依路由的 `titleKey` 更新頁籤標題。
 *
 * 用 `afterEach` 而非 `beforeEach`：導航若被守衛攔下重導，
 * 標題就不該先被改成那個沒真的進入的頁面。
 */
export function applyDocumentTitle(to: RouteLocationNormalized): void {
  const titleKey = to.meta.titleKey
  const appName = i18n.global.t('common.appName')

  document.title = titleKey === undefined ? appName : `${i18n.global.t(titleKey)} · ${appName}`
}
